// Shared vector artwork for DOM icons and painted board/relic textures.
const ART = {
  cornerBeacon: {
    lines: [
      [
        [3, 9],
        [3, 3],
        [9, 3],
      ],
      [
        [15, 3],
        [21, 3],
        [21, 9],
      ],
      [
        [21, 15],
        [21, 21],
        [15, 21],
      ],
      [
        [9, 21],
        [3, 21],
        [3, 15],
      ],
      [
        [6, 6],
        [10, 10],
      ],
      [
        [18, 6],
        [14, 10],
      ],
      [
        [18, 18],
        [14, 14],
      ],
      [
        [6, 18],
        [10, 14],
      ],
    ],
    circles: [[12, 12, 2]],
  },
  balancedGyro: {
    lines: [
      [
        [3, 12],
        [21, 12],
      ],
      [
        [12, 3],
        [12, 21],
      ],
      [
        [3, 7],
        [3, 17],
      ],
      [
        [21, 7],
        [21, 17],
      ],
    ],
    circles: [
      [12, 12, 7],
      [12, 12, 3],
    ],
  },
  relayCapacitor: {
    lines: [
      [
        [3, 6],
        [8, 6],
        [8, 12],
        [16, 12],
        [16, 18],
        [21, 18],
      ],
      [
        [10, 8],
        [13, 8],
        [11, 16],
        [14, 16],
      ],
    ],
    circles: [
      [3, 6, 2],
      [21, 18, 2],
    ],
  },
  anchorPlating: {
    lines: [
      [
        [12, 2],
        [21, 6],
        [19, 16],
        [12, 22],
        [5, 16],
        [3, 6],
        [12, 2],
      ],
      [
        [12, 8],
        [12, 18],
      ],
      [
        [7, 13],
        [7, 15],
        [12, 18],
        [17, 15],
        [17, 13],
      ],
    ],
    circles: [[12, 7, 2]],
  },
  hazardDividend: {
    lines: [
      [
        [12, 2],
        [22, 19],
        [2, 19],
        [12, 2],
      ],
      [
        [12, 7],
        [12, 12],
      ],
      [
        [6, 22],
        [18, 22],
      ],
    ],
    circles: [
      [12, 16, 1],
      [7, 16, 1],
      [17, 16, 1],
    ],
  },
  precisionDynamo: {
    lines: [
      [
        [12, 2],
        [12, 7],
      ],
      [
        [12, 17],
        [12, 22],
      ],
      [
        [2, 12],
        [7, 12],
      ],
      [
        [17, 12],
        [22, 12],
      ],
      [
        [12, 8],
        [10, 13],
        [14, 11],
        [12, 16],
      ],
    ],
    circles: [[12, 12, 8]],
  },
  mirrorChip: {
    lines: [
      [
        [6, 3],
        [18, 3],
        [18, 21],
        [6, 21],
        [6, 3],
      ],
      [
        [8, 5],
        [16, 5],
        [16, 19],
        [8, 19],
        [8, 5],
      ],
      [
        [9, 11],
        [13, 7],
      ],
      [
        [11, 16],
        [15, 12],
      ],
      [
        [2, 7],
        [6, 7],
      ],
      [
        [2, 12],
        [6, 12],
      ],
      [
        [2, 17],
        [6, 17],
      ],
      [
        [18, 7],
        [22, 7],
      ],
      [
        [18, 12],
        [22, 12],
      ],
      [
        [18, 17],
        [22, 17],
      ],
      [
        [10, 1],
        [10, 3],
      ],
      [
        [14, 1],
        [14, 3],
      ],
      [
        [10, 21],
        [10, 23],
      ],
      [
        [14, 21],
        [14, 23],
      ],
    ],
  },
  signalWarning: {
    lines: [
      [
        [3, 10],
        [3, 7],
        [12, 2],
        [21, 7],
        [21, 10],
      ],
      [
        [21, 14],
        [21, 17],
        [12, 22],
        [3, 17],
        [3, 14],
      ],
      [
        [1, 12],
        [5, 12],
      ],
      [
        [19, 12],
        [23, 12],
      ],
      [
        [12, 6],
        [11, 11],
        [13, 11],
        [12, 14],
      ],
    ],
    circles: [[12, 17, 0.7]],
  },
  relay: {
    lines: [
      [
        [4, 19],
        [4, 12],
        [12, 12],
        [12, 5],
        [20, 5],
      ],
      [
        [15, 1],
        [20, 5],
        [16, 10],
      ],
    ],
    circles: [[4, 19, 2]],
  },
  gambit: {
    lines: [
      [
        [5, 3],
        [19, 3],
        [21, 5],
        [21, 19],
        [19, 21],
        [5, 21],
        [3, 19],
        [3, 5],
        [5, 3],
      ],
    ],
    circles: [
      [8, 8, 1],
      [16, 8, 1],
      [12, 12, 1],
      [8, 16, 1],
      [16, 16, 1],
    ],
  },
  powerUp: {
    lines: [
      [
        [14, 2],
        [5, 13],
        [11, 13],
        [9, 22],
        [20, 9],
        [13, 9],
        [14, 2],
      ],
    ],
  },
  interference: {
    lines: [
      [
        [2, 7],
        [6, 4],
        [10, 7],
        [14, 4],
        [18, 7],
        [22, 4],
      ],
      [
        [2, 13],
        [6, 10],
        [10, 13],
        [14, 10],
        [18, 13],
        [22, 10],
      ],
      [
        [2, 19],
        [6, 16],
        [10, 19],
        [14, 16],
        [18, 19],
        [22, 16],
      ],
    ],
  },
  sabotage: {
    lines: [
      [
        [4, 5],
        [9, 5],
        [11, 2],
        [13, 5],
        [20, 5],
        [20, 20],
        [4, 20],
        [4, 5],
      ],
      [
        [8, 9],
        [16, 17],
      ],
      [
        [16, 9],
        [8, 17],
      ],
    ],
  },
  recharge: {
    lines: [
      [
        [5, 9],
        [5, 4],
        [10, 4],
      ],
      [
        [5, 4],
        [17, 4],
        [21, 10],
        [19, 18],
        [12, 22],
        [5, 18],
      ],
      [
        [10, 10],
        [16, 10],
        [12, 16],
        [14, 9],
      ],
    ],
  },
  crosswind: {
    lines: [
      [
        [2, 6],
        [17, 6],
        [20, 4],
        [18, 2],
      ],
      [
        [2, 12],
        [22, 12],
      ],
      [
        [17, 8],
        [22, 12],
        [17, 16],
      ],
      [
        [2, 18],
        [11, 18],
        [14, 20],
        [12, 22],
      ],
    ],
  },
  magnetic: {
    lines: [
      [
        [3, 3],
        [3, 13],
        [5, 18],
        [9, 21],
        [15, 21],
        [19, 18],
        [21, 13],
        [21, 3],
        [16, 3],
        [16, 13],
        [14, 16],
        [10, 16],
        [8, 13],
        [8, 3],
        [3, 3],
      ],
      [
        [3, 8],
        [8, 8],
      ],
      [
        [16, 8],
        [21, 8],
      ],
    ],
  },
  ice: {
    lines: [
      [
        [12, 2],
        [12, 22],
      ],
      [
        [3, 7],
        [21, 17],
      ],
      [
        [3, 17],
        [21, 7],
      ],
      [
        [8, 4],
        [12, 7],
        [16, 4],
      ],
      [
        [8, 20],
        [12, 17],
        [16, 20],
      ],
      [
        [3, 11],
        [7, 10],
        [7, 6],
      ],
      [
        [17, 18],
        [17, 14],
        [21, 13],
      ],
    ],
  },
  lowGravity: {
    lines: [
      [
        [12, 16],
        [12, 3],
      ],
      [
        [7, 8],
        [12, 3],
        [17, 8],
      ],
      [
        [3, 17],
        [6, 20],
        [18, 20],
        [21, 17],
      ],
    ],
    circles: [
      [4, 13, 1],
      [20, 13, 1],
    ],
  },
  stable: {
    lines: [
      [
        [12, 2],
        [22, 12],
        [12, 22],
        [2, 12],
        [12, 2],
      ],
      [
        [8, 12],
        [11, 15],
        [17, 8],
      ],
    ],
  },
  chainReaction: {
    lines: [
      [
        [12, 4],
        [12, 20],
      ],
      [
        [4, 12],
        [20, 12],
      ],
    ],
    circles: [
      [12, 3, 2],
      [3, 12, 2],
      [21, 12, 2],
      [12, 21, 2],
      [12, 12, 3],
    ],
  },
  phaseAnchor: {
    lines: [
      [
        [12, 7],
        [12, 21],
      ],
      [
        [6, 11],
        [18, 11],
      ],
      [
        [3, 15],
        [6, 19],
        [12, 22],
        [18, 19],
        [21, 15],
      ],
      [
        [3, 15],
        [3, 19],
      ],
      [
        [21, 15],
        [21, 19],
      ],
    ],
    circles: [[12, 4, 3]],
  },
  heart: {
    lines: [
      [
        [12, 21],
        [3, 12],
        [3, 7],
        [6, 3],
        [10, 3],
        [12, 6],
        [14, 3],
        [18, 3],
        [21, 7],
        [21, 12],
        [12, 21],
      ],
      [
        [7, 12],
        [10, 12],
        [12, 8],
        [14, 16],
        [16, 12],
        [18, 12],
      ],
    ],
  },
  shield: {
    lines: [
      [
        [12, 2],
        [21, 6],
        [20, 14],
        [17, 19],
        [12, 22],
        [7, 19],
        [4, 14],
        [3, 6],
        [12, 2],
      ],
      [
        [12, 6],
        [12, 18],
      ],
      [
        [7, 10],
        [17, 10],
      ],
    ],
  },
  flame: {
    lines: [
      [
        [12, 2],
        [16, 8],
        [20, 10],
        [21, 16],
        [18, 21],
        [7, 21],
        [3, 17],
        [4, 11],
        [7, 14],
        [8, 7],
        [12, 2],
      ],
      [
        [12, 12],
        [16, 17],
        [14, 21],
        [10, 21],
        [8, 17],
        [12, 12],
      ],
    ],
  },
};
export const getCoreboundIconArt = (name = 'relic') => {
  if (ART[name]) return ART[name];
  const key = name.toLowerCase();
  if (/heal|heart|patch|blood|vital|bandage/.test(key)) return ART.heart;
  if (/shield|guard|block|shell|aegis|firewall/.test(key)) return ART.shield;
  if (/dice|roll|gambit|mirror|lucky/.test(key)) return ART.gambit;
  if (/burn|fire|ember|flame/.test(key)) return ART.flame;
  let hash = 2166136261;
  for (const char of name)
    hash = Math.imul(hash ^ char.charCodeAt(0), 16777619) >>> 0;
  const points = [
    [6, 7],
    [12, 5],
    [18, 7],
    [19, 14],
    [15, 19],
    [8, 18],
    [5, 13],
  ];
  const nodes = points.filter((_, index) => (hash >>> index) & 1);
  return {
    lines: [
      [
        [7, 2],
        [17, 2],
        [22, 7],
        [22, 17],
        [17, 22],
        [7, 22],
        [2, 17],
        [2, 7],
        [7, 2],
      ],
      ...nodes.map((point) => [point, [12, 12]]),
    ],
    circles: [[12, 12, 2.5], ...nodes.map(([x, y]) => [x, y, 1.3])],
  };
};
export const drawCoreboundIcon = (context, name, color, x, y, size) => {
  const art = getCoreboundIconArt(name);
  context.save();
  context.translate(x, y);
  context.scale(size / 24, size / 24);
  context.strokeStyle = color;
  context.lineWidth = 1.6;
  context.lineCap = context.lineJoin = 'round';
  context.beginPath();
  (art.lines || []).forEach((points) =>
    points.forEach(([px, py], index) =>
      index ? context.lineTo(px, py) : context.moveTo(px, py)
    )
  );
  (art.circles || []).forEach(([cx, cy, r]) => {
    context.moveTo(cx + r, cy);
    context.arc(cx, cy, r, 0, Math.PI * 2);
  });
  context.stroke();
  context.restore();
};
